import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import api from "api";
import _ from "lodash";
import update from 'immutability-helper';
import { AvatarVertical1 } from "component/Avatar";
import { StarsList } from "component/Rating";
import "./index.scss";
import {ReactComponent as SVGStar} from '../../assets/star.svg';

const RisingStar = (props) => {
    const [users, setUsers]     = useState(false);
    const [total, setTotal]         = useState(false);
    const [listArgs, setListArgs]   = useState(props.listArgs || {});

    const [paginationParams]     = useState({
        paged : 1
        ,posts_per_page : 1
    });


    useEffect(() => {
        
        setListArgs(props.listArgs);

    },props.listArgs ? [props.listArgs.refresh] : []);

    useEffect(() => {

        setUsers(false);

        var args = _.assignIn({}, paginationParams, listArgs );

        var toFetch = [
            api('/RisingStars', 'get', args)
        ]

        Promise.all(toFetch)
            .then((response) => {


                setUsers(_.map(response[0].user, (user) => {
                    return user;
                }));

                if(args.paged == 1)
                {
                    // setTotal(parseInt(response[1].user) );
                }
            })
            .catch((error) => {
                setUsers([]);
            })

    }, [listArgs]);

    return (
        <div className="component-user-rising-star">
            <ul className="user-users">
                {
                    users !== false && users.map((user) => (
                        <li className="user-profile" key={user.UserID}>
                            <div className="user-profile-wrapper">
                                <div className="user-profile-user">
                                    <AvatarVertical1 user={user}>
                                        <div className="user-rating">
                                            <div className="user-score">
                                                {user.UserScore}
                                            </div>
                                            <div className="user-stars">
                                                <StarsList score={user.UserScore} />
                                            </div>
                                        </div>
                                    </AvatarVertical1>
                                </div>
                            </div>
                        </li>
                    ))
                }
                {
                    users === false && <li className="user-profile"><span className="skeleton"></span></li> 
                }
            </ul>
            {
                users !== false && users.length == 0 &&
                <div className="text-xs italic">We are still looking for the best talent, is that you?</div>
            }
        </div>
    )
}

export { RisingStar }